import { useState, useRef } from 'react'

import useClickOutside from 'hooks/useClickOutside'

import { ReactComponent as IconSearch } from 'assets/icons/IconSearch.svg'
import { ReactComponent as IconChevron } from 'assets/icons/IconChevron.svg'

const SearchBar = ({
  searchQuery,
  handleSearch,
  options,
  handleSelectOption,
  selectedOption,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false)

  const dropdownRef = useRef(null)
  const buttonRef = useRef(null)

  useClickOutside(
    dropdownRef,
    buttonRef,
    setDropdownOpen,
    isDropdownOpen
  )

  return (
    <div className="search-bar">
      <input
        className="search-bar__input"
        placeholder="Search"
        type="text"
        value={searchQuery}
        onChange={handleSearch}
      />
      <div className="search-bar__dropdown">
        <span
          onClick={() => setDropdownOpen(true)}
          role="button"
          className="search-bar__dropdown-selected-item"
          ref={buttonRef}
        >
          {selectedOption?.label}
          <IconChevron className="search-bar__dropdown-icon" />
        </span>
        {isDropdownOpen && (
          <ul ref={dropdownRef} className="search-bar__dropdown-list">
            {options?.map(({ uuid, label }) => (
              <li
                onClick={() => {
                  handleSelectOption(uuid)
                  setDropdownOpen(false)
                }}
                role="button"
                id={uuid}
                key={uuid}
                className="search-bar__dropdown-item"
              >
                {label}
              </li>
            ))}
          </ul>
        )}
      </div>
      <span className="search-bar__icon">
        <IconSearch />
      </span>
    </div>
  )
}

SearchBar.defaultProps = {
  setPaginationToDefault: () => {},
}

export default SearchBar
